import React from 'react';
import ConsultBanner from '../../components/ConsultBaneer';
import ConsultCard from '../../components/ConsultCard';


const Consult = () => {
  return (
    <div>
  <ConsultBanner />
  <ConsultCard />
</div>

  );
};

export default Consult;
